import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import {SiteGetInfoService} from '../../services/site-get-info.service';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Contact} from '../../../shared/models/contact';
import {EMAIL_PATTERN, PHONE_NUMBER_PATTERN} from '../../../shared';
import {Router} from '@angular/router';

@Component({
  selector: 'storever-contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.scss']
})
export class ContactEditComponent implements OnInit, OnDestroy  {

  dataConfig: DataConfig;
  content: Observable<Contact[]>;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];

  constructor(private siteGetInfoService: SiteGetInfoService, private fb: FormBuilder , private router: Router) { }

  ngOnInit(): void {
    this.dataConfig.form.disable();
    this.content = this.dataConfig.content;
    this.content.subscribe((contacts: Contact[]) => {
      for (let i = 0; i < contacts.length; i++) {
        if (!this.form.at(i)) {
          this.add();
        }
        this.form.at(i).patchValue(contacts[i]);
      }
    })
  }

  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();

    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  /**
   * - getRawValue from FormGroup even if disabled
   * - Update/patch part of the order
   * @param apiName
   */
  save(apiNames: string[]): void {
    const poz = +apiNames[2];
    const resp = this.getFormAt(poz).value;
    if (this.router.url.split('?')[0].search('multi') !== -1) {
      this.saveForm.emit({ type: 'multiSubscription' , api: apiNames, data: resp });
    }
    else {
      this.saveForm.emit({ api: apiNames, data: resp });
    }
  }

  undo(formPath: string[]): void {
    this.dataConfigContentPatchForm(formPath);
  }

  dataConfigContentPatchForm(formPath?: string[]): void {
    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe(sub => {
      if (formPath) {
        this.getFormAt(+formPath[1]).patchValue(sub[+formPath[1]]);
      } else {
        this.form.patchValue(sub);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  get form(): FormArray {
    return this.dataConfig.form.get('contacts') as FormArray
  }

  isOrderOpened(): Observable<boolean> {
    return this.siteGetInfoService.isOrderOpened()
  }

  getFormAt(poz: number): FormGroup {
    return this.form.at(poz) as FormGroup;
  }

  add(): void {
    this.form.push(this.fb.group({
      comments: [null],
      culture: [null],
      created: [null],
      createdBy: [null],
      department: [null],
      email: [null, [Validators.required, Validators.pattern(EMAIL_PATTERN)]],
      groupRole: [null],
      id: [null],
      mobile: [null],
      name: [null, Validators.required],
      phone: [null, [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)]],
      sex: [null],
      skype: [null],
      surname: [null, Validators.required],
      typeUser: [null],
      uuid: [null],
      updated: [null],
      updatedBy: [null]
    }));
  }

  get isStatusOff$(): Observable<boolean> {
    return this.siteGetInfoService.isStatusOff()
  }

}

